import {LocaleEnum, type SlugLocale} from '../types/locale';

export const hrefLangXDefault = (slugLocales: SlugLocale[]) => {
  const enUsEntry = slugLocales.find(item => item.locale === LocaleEnum.EN);
  if (enUsEntry) {
    return enUsEntry;
  }
  const deDeEntry = slugLocales.find(item => item.locale === LocaleEnum.DE);
  if (deDeEntry) {
    return deDeEntry;
  }
  const deAtEntry = slugLocales.find(item => item.locale === LocaleEnum.AT);
  if (deAtEntry) {
    return deAtEntry;
  }
  const deChEntry = slugLocales.find(item => item.locale === LocaleEnum.CH);
  if (deChEntry) {
    return deChEntry;
  }
  const enIEEntry = slugLocales.find(item => item.locale === LocaleEnum.IE);
  if (enIEEntry) {
    return enIEEntry;
  }
};
